/**
 * Custom event broadcast by the Coveo URL managers (V1 and V2) immediately
 * after they write to history via `pushState`/`replaceState`. Those native
 * methods don't fire any event, so subscribers outside the engine (e.g. a
 * page-level results banner) need this signal to stay in sync with the
 * current sale filter.
 */
export const COVEO_URL_CHANGE_EVENT = 'coveo:urlchange';

export function dispatchCoveoUrlChange(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(COVEO_URL_CHANGE_EVENT));
}
